import { createContext } from "react";

export const AcolitosContext = createContext();
